export default __webpack_public_path__ + "static/VRLifeSavingRules-f5de370c3cd35c5f0fb039d43229fabb.jpg";